<template>
  <h3 v-if="planNameToDisplay !== '0 GB'" aria-hidden="true" class="heading-xs">
    <span v-if="strikeThroughPlanToDisplay" class="line-through">
      {{ strikeThroughPlanToDisplay }}
    </span>
    {{ overrideTitle ?? planNameToDisplay }}
  </h3>

  <h3 v-if="planNameToDisplay !== '0 GB'" class="sr-only">
    <span v-if="strikeThroughPlanToDisplay">
      {{ `Tidigare ${strikeThroughPlanToDisplay} GB, nu ` }}
    </span>
    {{ planNameToDisplay }}.
  </h3>
</template>

<script lang="ts" setup>
interface Props {
  productName?: string;
  regularDataAllowance?: number;
  dataAllowance?: number;
  hasExtraAllowance: boolean;
  overrideTitle?: string;
}

const props = defineProps<Props>();

const planNameToDisplay = computed(() =>
  props.productName && !props.dataAllowance
    ? props.productName
    : `${props.dataAllowance} GB`,
);

const strikeThroughPlanToDisplay = computed(() =>
  props.hasExtraAllowance ? `${props.regularDataAllowance || ''}` : '',
);
</script>
